import React, { useEffect, useState } from 'react';
import { supabaseClient } from '../../config/supabase';
import { storeUrl } from '../../lib/inviteInstallLinks';

export default function InviteInstallSettings({ orgId }) {
    const [urls, setUrls] = useState({ app_store_url: '', google_play_url: '' });
    const [busy, setBusy] = useState(true);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    useEffect(() => {
        let active = true;
        if (!orgId) { setBusy(false); return () => { active = false; }; }
        supabaseClient.from('org_settings').select('app_store_url, google_play_url').eq('org_id', orgId).maybeSingle()
            .then(({ data, error: failure }) => {
                if (!active) return;
                if (failure) setError(failure.message);
                else if (data) setUrls(data);
            }).catch((failure) => { if (active) setError(failure.message); })
            .finally(() => { if (active) setBusy(false); });
        return () => { active = false; };
    }, [orgId]);
    async function save(event) {
        event.preventDefault();
        setBusy(true);
        setError('');
        setMessage('');
        try {
            const values = {
                app_store_url: storeUrl(urls.app_store_url.trim(), 'apple'),
                google_play_url: storeUrl(urls.google_play_url.trim(), 'google'),
            };
            const { error: failure } = await supabaseClient.from('org_settings').upsert({ org_id: orgId, ...values }, { onConflict: 'org_id' });
            if (failure) throw new Error(failure.message);
            setUrls(values);
            setMessage('Invitation install links saved.');
        } catch (failure) {
            setError(failure.message);
        } finally { setBusy(false); }
    }
    return (
        <form onSubmit={save} className="space-y-3 rounded-lg border border-[var(--surface-border)] p-4">
            <h3>Invitation install links</h3>
            <p>Only add published native-app listings. Leave a field blank to omit that store link. Web install instructions are always included.</p>
            <label className="block">App Store URL
                <input className="block w-full" type="url" value={urls.app_store_url} onChange={(event) => setUrls({ ...urls, app_store_url: event.target.value })} />
            </label>
            <label className="block">Google Play URL
                <input className="block w-full" type="url" value={urls.google_play_url} onChange={(event) => setUrls({ ...urls, google_play_url: event.target.value })} />
            </label>
            <button type="submit" disabled={busy || !orgId}>Save install links</button>
            {error && <p role="alert">{error}</p>}
            {message && <p role="status">{message}</p>}
        </form>
    );
}
